export interface DuviNicheSiteTrustStripProps {
  line: string;
  /** How many placeholder marks to lay out. */
  logoCount?: number;
}

/** Placeholder mark widths, cycled — the export's own figures. */
const DUVI_NICHE_SITE_TRUST_MARK_WIDTHS = [104, 88, 120, 96, 110];

/**
 * DuviNicheSiteTrustStrip — ported from the bespoke Fishwalkers design
 * system's `components/marketing/TrustStrip.jsx`
 * (duvi-design/exports/niches/fishwalkers/system.zip): one reassurance line
 * over a row of walker marks on the soft paper band.
 *
 * The marks are deliberately blank shapes and `aria-hidden`. No walker has
 * consented to appear here and no real logo exists, so inventing named
 * placeholders ("Guide A", "Guide B") would put fabricated endorsements on a
 * live marketing page — the export renders unlabelled blocks for exactly that
 * reason, and this port keeps it.
 */
export function DuviNicheSiteTrustStrip({
  line,
  logoCount = 4,
}: DuviNicheSiteTrustStripProps) {
  return (
    <section className="w-full bg-[var(--surface-soft)] py-[var(--space-10)]">
      <div className="mx-auto flex w-full max-w-[var(--container-max)] flex-col items-center gap-[var(--space-6)] px-[var(--container-pad)] lg:px-[var(--container-pad-lg)]">
        <p className="m-0 text-center font-[family-name:var(--font-body)] text-[15px] font-medium text-[color:var(--muted)]">
          {line}
        </p>
        <ul
          aria-hidden="true"
          className="m-0 flex list-none flex-wrap items-center justify-center gap-[var(--space-8)] p-0"
        >
          {Array.from({ length: logoCount }).map((_, index) => (
            <li
              key={index}
              className="h-[22px] rounded-[4px] bg-[var(--border)]"
              style={{
                width:
                  DUVI_NICHE_SITE_TRUST_MARK_WIDTHS[
                    index % DUVI_NICHE_SITE_TRUST_MARK_WIDTHS.length
                  ],
              }}
            />
          ))}
        </ul>
      </div>
    </section>
  );
}
